
export default {
    computed: {
        isPlayGamePage() {
            if (this.$route.path === '/play-game') return true
            return false
        },
    },
}
